import { render, staticRenderFns } from "./SANewsCard.html?vue&type=template&id=121a590a&scoped=true&"
import script from "./SANewsCard.ts?vue&type=script&lang=ts&"
export * from "./SANewsCard.ts?vue&type=script&lang=ts&"
import style0 from "./SANewsCard.css?vue&type=style&index=0&id=121a590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a590a",
  null
  
)

export default component.exports